import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, Float32Field, PointerField, Field, StringField, BooleanField, Int32Field, ArrayField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class StepsModulatorBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new StepsModulatorBox({
            uuid,
            graph,
            name: "StepsModulatorBox",
            pointerRules: {
                accepts: [Pointers.Selection, Pointers.MetaData],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "StepsModulatorBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "modulator" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitStepsModulatorBox, this);
    }
    get tags() {
        return StepsModulatorBox.Tags;
    }
    get collection() {
        return this.getField(1);
    }
    get assignments() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get index() {
        return this.getField(5);
    }
    get tracks() {
        return this.getField(6);
    }
    get bipolar() {
        return this.getField(7);
    }
    get amount() {
        return this.getField(8);
    }
    get count() {
        return this.getField(10);
    }
    get rateSync() {
        return this.getField(11);
    }
    get rateAbsolute() {
        return this.getField(12);
    }
    get phase() {
        return this.getField(13);
    }
    get smooth() {
        return this.getField(15);
    }
    get direction() {
        return this.getField(16);
    }
    get steps() {
        return this.getField(20);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "collection",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.ModulatorCollection, true),
            2: Field.hook({
                parent: this,
                fieldKey: 2,
                fieldName: "assignments",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.ModulatorSource],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            6: Field.hook({
                parent: this,
                fieldKey: 6,
                fieldName: "tracks",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.TrackCollection],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            7: BooleanField.create({
                parent: this,
                fieldKey: 7,
                fieldName: "bipolar",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            8: Float32Field.create({
                parent: this,
                fieldKey: 8,
                fieldName: "amount",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 1),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "count",
                deprecated: false,
                pointerRules: NoPointers,
            }, { min: 1, max: 64 }, "", 16),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "rateSync",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 12 }, "", 10),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "rateAbsolute",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 10, scaling: "linear" }, "Hz", 0),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "phase",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 0),
            15: Float32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "smooth",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIControl, Pointers.Automation],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 0),
            16: Int32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "direction",
                deprecated: false,
                pointerRules: NoPointers,
            }, { values: [0, 1, 2, 3, 4] }, "", 0),
            20: ArrayField.create({
                parent: this,
                fieldKey: 20,
                fieldName: "steps",
                deprecated: false,
                pointerRules: NoPointers,
            }, (construct) => Float32Field.create(construct, "unipolar", "%", 0.5), 64),
        };
    }
}
